// src/layouts/trafficmonitoring/monitoring/data/fetchActiveEvents.js
import axios from "axios";
// import config from "../../../../config";

import config from "../../../config"

const API_URL = config.TRAFFIC;

export async function fetchHistoricalData(endpoint) {
  try {
    const response = await axios.get(
      `${API_URL}${endpoint}`,
      { headers: { "Accept-Profile": "traffic_athens" } }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching route events:", error);
    return [];
  }
}
